var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["../layout.njk"] = require( "../layout.njk" );




var shim = require("D:/workspace/indivior-listmypractice-release/frontend/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["src/views/pages/access-your-listing.njk"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("../layout.njk", true, "src/views/pages/access-your-listing.njk", false, function(t_3,t_2) {
if(t_3) { cb(t_3); return; }
parentTemplate = t_2
for(var t_1 in parentTemplate.blocks) {
context.addBlock(t_1, parentTemplate.blocks[t_1]);
}
output += "\r\n\r\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("meta_title"))(env, context, frame, runtime, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
output += t_4;
output += "\r\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("meta_description"))(env, context, frame, runtime, function(t_7,t_6) {
if(t_7) { cb(t_7); return; }
output += t_6;
output += "\r\n\r\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("body_class"))(env, context, frame, runtime, function(t_9,t_8) {
if(t_9) { cb(t_9); return; }
output += t_8;
output += "\r\n\r\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("content"))(env, context, frame, runtime, function(t_11,t_10) {
if(t_11) { cb(t_11); return; }
output += t_10;
output += "\r\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_meta_title(env, context, frame, runtime, cb) {
var lineno = 2;
var colno = 3;
var output = "";
try {
var frame = frame.push(true);
output += "Manage Your Listing | List My Practice";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_meta_description(env, context, frame, runtime, cb) {
var lineno = 3;
var colno = 3;
var output = "";
try {
var frame = frame.push(true);
output += "Access and edit your practice locations within the Indivior Find a SUBLOCADE® (buprenorphine extended-release) Treatment Provider Tool.";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_body_class(env, context, frame, runtime, cb) {
var lineno = 5;
var colno = 3;
var output = "";
try {
var frame = frame.push(true);
output += "access-listing";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_content(env, context, frame, runtime, cb) {
var lineno = 7;
var colno = 3;
var output = "";
try {
var frame = frame.push(true);
output += "\r\n  <main id=\"main-content\">\r\n    <section>\r\n      <div class=\"container\">\r\n        <h1 class=\"mt-0\">Access your listing</h1>\r\n        <h2 class=\"mt-0 mb-30 color-copy\">Enter your credentials to view your&nbsp;information.</h2>\r\n        <form action=\"\" class=\"sign-in-form\" id=\"sign-in-form\" name=\"Sign In\" method=\"post\" aria-label=\"Practice Listing Tool Login\">\r\n          <div class=\"form-group\">\r\n            <div class=\"row\">\r\n              <div class=\"one-half column\">\r\n                <label id=\"npi-label\" for=\"npi\">NPI\r\n                  <p class=\"form-error error-required hidden flex-vertical-center\">Please ensure the NPI Number format is valid. NPI Number is 10 digits in length.</p>\r\n                </label>\r\n                <input class=\"\" id=\"npi\" name=\"npi\" placeholder=\"\" type=\"text\" value=\"\" aria-required=\"true\" maxlength=\"10\">\r\n              </div>\r\n            </div>\r\n            <div class=\"row\">\r\n              <div class=\"one-half column mt-10\">\r\n                <label id=\"dea-label\" for=\"dea\">DEA\r\n                  <p class=\"form-error error-required hidden flex-vertical-center\">Please note that only states for which you have a valid DEA number will be allowed. DEA Number is 9 alphanumeric characters in length.</p>\r\n                </label>\r\n                <input class=\"\" id=\"dea\" name=\"dea\" placeholder=\"\" type=\"text\" value=\"\" aria-required=\"true\" maxlength=\"9\">\r\n              </div>\r\n            </div>\r\n            <div class=\"row\">\r\n              <div class=\"one-half column mt-10\">\r\n                <label id=\"last-name-label\" for=\"last-name\">Last Name\r\n                  <p class=\"form-error error-required hidden flex-vertical-center\">A Last Name is required. Please use Last Name associated with credentials.</p>\r\n                </label>\r\n                <input class=\"\" id=\"last-name\" name=\"last-name\" placeholder=\"\" type=\"text\" value=\"\" aria-required=\"true\" maxlength=\"500\">\r\n              </div>\r\n            </div>\r\n            <div class=\"row\">\r\n              <div class=\"one-half column mt-10\">\r\n                <label id=\"email-label\" for=\"email\">Email Address\r\n                  <p class=\"form-error error-required hidden flex-vertical-center\">Please enter individual healthcare provider email address. Group or administrator email addresses are not accepted.</p>\r\n                </label>\r\n                <input class=\"email\" id=\"email\" name=\"email\" placeholder=\"\" type=\"email\" value=\"\" aria-required=\"true\" maxlength=\"100\">\r\n                <small>Enter individual healthcare provider email address. Group or administrator email addresses are not accepted.</small>\r\n              </div>\r\n            </div>\r\n            <div class=\"row\">\r\n              <div class=\"one-half column mt-30\">\r\n                <button type=\"submit\" class=\"btn btn-min-width btn-primary\" id=\"validate-credentials\">\r\n                  <span class=\"btn-content\">Sign In</span></button>\r\n                <svg class=\"svg--icon-loading hidden\" id=\"validate-credentials-loading\">\r\n                  <use xlink:href=\"#icon-loading\"></use>\r\n                </svg>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </form>\r\n      </div>\r\n\r\n    <div class=\"container mt-10\">\r\n        <p id=\"access-disclaimer\" class=\"h2 color-copy\">If you are unable to log in, please review the <a href=\"/faqs\"><b>FAQ</b></a> page for troubleshooting tips. If you have additional technical questions, please contact support at <a href=\"mailto:HCP_INFO@Indivior.com\" target=\"_blank\"><b>HCP_INFO@Indivior.com</b></a>.</p>\r\n    </div>\r\n\r\n      <div class=\"container mt-10\">\r\n        <p>Use this website to access and edit your location for use in the Indivior Find a SUBLOCADE Treatment Provider Tool for patients. Inclusion in this tool means that your name and practice location will be searchable via ZIP code by patients or caregivers looking for a SUBLOCADE treatment provider, while they are using the INSUPPORT&reg; or Indivior brand websites.</p>\r\n      </div>\r\n    </section>\r\n  </main>\r\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
b_meta_title: b_meta_title,
b_meta_description: b_meta_description,
b_body_class: b_body_class,
b_content: b_content,
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["src/views/pages/access-your-listing.njk"] , dependencies)